/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { IconDownload, IconEye, IconPlus } from "@tabler/icons-react";
import ColumnsFilter from "../../../components/common/ColumnsFilter";
import DropdownFilter from "../../../components/common/DropdownFilter";
import ListView from "../../../components/common/ListView";
import NormalSearch from "../../../components/common/NormalSearch";
import { useNavigate } from "react-router-dom";
import ToggleButton from "../../../components/ToggleButton";
import {
  useFetchRoutesData,
  useRouteStatusMutation,
} from "../../../apis/routeApis";
import formatDate from "../../../utilities/helper";
import TableSkeleton from "../../../components/skeleton/TableSkeleton";
import useDebounce from "../../../utilities/useDebounce";
import Pagination from "../../../components/common/Pagination";
import MessageModal from "../../../components/MessageModal";
import toast from "react-hot-toast"; 

const RouteListManagement = () => {
  const navigate = useNavigate();
  const [searchFor, setSearchFor] = useState<string>("");
  const [pageNo, setPageNo] = useState<number>(1);
  const [limit, setLimit] = useState(10)
  const [activeModal, setActiveModal] = useState<boolean>(false);
  const [status, setStatus] = useState<string>("");
  const [id, setId] = useState<string>("");
  const { mutate: statusMutate, isPending: isStatusPending } =
    useRouteStatusMutation(id);
  const {
    data: routes,
    isPending: listPending,
    refetch,
  } = useFetchRoutesData(pageNo,limit, searchFor);

  const handlePaginationFetch = (page: number) => {
    setPageNo(page);
  };

  const debouncedSearchFor = useDebounce(searchFor, 550);

  useEffect(() => {
    refetch();
  }, [debouncedSearchFor, pageNo]);

  const updateStatus = () => {
    statusMutate(
      { status: status === "ACTIVE" ? "INACTIVE" : "ACTIVE" },
      {
        onSuccess: (data: any) => {
          setActiveModal(false);
          refetch();
        },
        onError: (error: any) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      }
    );
  };

  return (
    <>
      <div className="rounded-3xl">
        <div className="flex items-start">
          <div className=" bg-[#F7F6F2] flex items-center justify-between px-6 py-3 w-full rounded-tl-3xl rounded-tr-[30px] ">
            <h1 className="text-3xl text-[#212121]">Route List</h1>
            <div className="flex items-center gap-2">
              <ColumnsFilter columnsData={[]} />
              <DropdownFilter filterheadings={[]} />
              <NormalSearch
                value={searchFor}
                onChange={(e) => {
                  setSearchFor(e.target.value);
                  setPageNo(1);
                }}
              />
            </div>
          </div>
          <div className="relative ml-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={40}
              height={40}
              viewBox="0 0 34 34"
              fill="none"
              className="absolute -bottom-[12.5px] -left-[22.5px] rotate-[2deg] "
            >
              <path
                d="M0.5 0.5C4.94768 14.4784 15.2221 25.8511 28.6786 31.6907L34 34H2.31268L0.5 0.5Z"
                fill="#F7F6F2"
              />
            </svg>

            <div className=" flex items-center gap-2 justify-end rounded-full">
              <button className="flex items-center gap-1  p-3 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]">
                <IconDownload stroke={1.5} size={24} />
              </button>
              <button onClick={() => navigate(`/route-add`)} className="flex items-center gap-1  p-3 text-sm rounded-full border border-[#FFFFFF] bg-[#F7F6F2]">
                <IconPlus stroke={1.5} size={24} />
              </button>
            </div>
          </div>
        </div>
        <div>
          {" "}
          {listPending ? (
            <TableSkeleton
              columns={[
                "S/N",
                "Route Code",
                "Route Name",
                "City",
                "District",
                "Created On",
                // "Route Type",
                "Status",
                "Actions",
              ]}
              rows={6}
            />
          ) : (
            <ListView
              data={routes?.routes}
              onRowClick={(vehicle) => console.log("Clicked:", vehicle)}
              columns={[
                { label: "#", render: (_, i) =>  (pageNo - 1) * limit + (i + 1)  },
                { label: "Route Code", render: (c: any) => c.routeCode },
                {
                  label: "Route Name",
                  render: (c: any) => c.routeName,
                },
                { label: "City", render: (c: any) => c.cityName },
                {
                  label: "District",
                  render: (c: any) => c.districtNames.join(", "),
                },
                {
                  label: " Created On",
                  render: (c: any) => formatDate(c.createdAt),
                },
                {
                  label: "Status",
                  render: (c: any) => (
                    <ToggleButton
                      onChange={() => {
                        setId(c?.id);
                        setStatus(c?.status);
                        setActiveModal(true);
                      }}
                      checked={c?.status === "ACTIVE"}
                    />
                  ),
                },
                {
                  label: "Actions",
                  render: (c) => (
                    <button
                      onClick={() => navigate(`/route-assign/${c.id}`)}
                      className="p-2 border rounded-full bg-[#F7F6F2]"
                    >
                      <IconEye />
                    </button>
                  ),
                },
              ]}
            />
          )}
          {routes?.totalPages > 1 && (
            <Pagination
              currentPage={pageNo}
              totalPages={routes?.totalPages}
              fetchData={handlePaginationFetch}
            />
          )}
        </div> 
      </div>

      <MessageModal
        open={activeModal}
        onClose={() => setActiveModal(false)}
        title="Confirmation Required"
        subtitle="Are you sure you want to perform this action?"
        img={status === "ACTIVE" ? "/img/inactive.svg" : "/img/active.svg"}
        showFooter={true}
        closeButtonText="Cancel"
        actionButtonText="Confirm"
        actionButtonOnClick={updateStatus}
        isPending={isStatusPending}
        size="md"
      />
    </>
  );
};

export default RouteListManagement;
